import { CloudOff, RotateCw } from "lucide-react";

/**
 * Issue #1316 — the board's failed-load card, in `PlanGoalsList`'s anatomy
 * (D53: loading, failed and empty are separate states). "Nothing has been
 * lost — we just couldn't reach the server." with a Try again at 44px.
 */
export default function LoadFailedCard({ title, testId, retryTestId, onRetry }) {
  return (
    <div
      data-testid={testId}
      role="alert"
      style={{ display: "flex", flexDirection: "column", gap: 8, padding: 16, background: "var(--nw-surface)", border: "1px solid var(--nw-line)", borderRadius: "var(--nw-radius-card)" }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <CloudOff size={20} color="var(--nw-alert)" strokeWidth={2} aria-hidden="true" style={{ flexShrink: 0 }} />
        <div style={{ fontWeight: 600, fontSize: 15, color: "var(--nw-ink)" }}>{title}</div>
      </div>
      <div style={{ fontSize: 13, lineHeight: 1.5, color: "var(--nw-ink-muted)" }}>Nothing has been lost — we just couldn't reach the server.</div>
      <button
        type="button"
        onClick={onRetry}
        data-testid={retryTestId}
        style={{
          alignSelf: "flex-start",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          minHeight: 44,
          padding: "0 14px",
          background: "var(--nw-surface)",
          border: "1px solid var(--nw-line-strong)",
          borderRadius: "var(--nw-radius-control)",
          fontSize: 14,
          fontWeight: 600,
          color: "var(--nw-navy)",
          cursor: "pointer",
        }}
      >
        <RotateCw size={14} strokeWidth={2} aria-hidden="true" />
        Try again
      </button>
    </div>
  );
}
